import { AttachmentFileType } from '../types/AttachmentFile';
import MailItemFile, { MailItemFileList } from '../types/MailItemFile';
import { trace } from 'owa-trace';

export default function createMailItemFiles(
    subjects: string[],
    latestItemIds: string[],
    sizes?: number[]
): MailItemFileList {
    if (subjects.length != latestItemIds.length) {
        trace.error('The sizes of subjects and latestItemIds are different');
        return null;
    }

    const mailItemList: MailItemFile[] = [];
    for (let i = 0; i < subjects.length; i++) {
        const conversation: MailItemFile = {
            fileType: AttachmentFileType.MailItem,
            name: subjects[i],
            size: (sizes && sizes[i]) || 0,
            itemId: latestItemIds[i],
        };

        mailItemList.push(conversation);
    }
    return mailItemList;
}
